import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pipeClient'
})
export class PipeClientPipe implements PipeTransform {

  transform(value: string | number, dv: string): string {
    if (!value) return '';
    
    let rut = value.toString();
    let formattedRut = '';
    
    // Insertar puntos cada tres dígitos desde la derecha
    while (rut.length > 3) {
      formattedRut = '.' + rut.slice(-3) + formattedRut;
      rut = rut.slice(0, -3);
    }

    formattedRut = rut + formattedRut;
    
    // Agregar el dígito verificador
    formattedRut += `-${dv}`;

    return formattedRut;
  }

}
